import React, { lazy } from 'react';
import { Gift, Star } from 'lucide-react';
import { Volleyball } from './Volleyball';
export function BonusesSection() {
  const bonuses = [{
    number: 'Bonus 1',
    title: 'Simple Scouting Kit',
    value: 'Value $47',
    desc: "Learn to analyze your opponents and your own team's stats without expensive software.",
    image: 'https://cdn.magicpatterns.com/uploads/6aLk85eTmqQRJNU3cJQMt5/cae69b2d-b133-4e69-886b-2228867245a6-mockup.webp'
  }, {
    number: 'Bonus 2',
    title: 'The Strategic Season Planner',
    value: 'Value $37',
    desc: 'Your annual agenda ready to use, aligned with the rhythm of the season.',
    image: 'https://cdn.magicpatterns.com/uploads/svxWSFSJFELFmTm6ZnbtoD/296f480f-6b56-4b66-a42c-a3e325d8326e-mockup.webp'
  }, {
    number: 'Bonus 3',
    title: 'Team Culture & Discipline Protocol',
    value: 'Value $27',
    desc: 'A code of conduct template to instill discipline, respect, and team grit.',
    image: 'https://cdn.magicpatterns.com/uploads/tL3JSNcd9bqZxvnGqC6tXL/3e2dcaa7-7060-4a28-b0ff-e376686025fa-mockup.webp'
  }, {
    number: 'Bonus 4',
    title: 'Performance Testing Guide',
    value: 'Value $27',
    desc: "Key protocols to evaluate your players' vertical jump, agility, and overall progress.",
    image: 'https://cdn.magicpatterns.com/uploads/eUaqyKK2MG94yFc3HajUWg/827bab8b-baee-435d-876a-cf4adc36827b-mockup.webp'
  }, {
    number: 'Bonus 5',
    title: 'MVP Certificates & Awards',
    value: 'Value $17',
    desc: 'Print-ready templates to reward your players and boost team morale.',
    image: 'https://cdn.magicpatterns.com/uploads/d513zheGzRJLy67bF9LddJ/80357283-719f-425a-acd8-f2156fdd942f-mockup.webp'
  }];
  return <section className="bg-pilates-soft py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden border-t border-pilates-slate/10" data-id="element-28">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-29">
        <div className="text-center mb-14" data-id="element-30">
          <div className="border border-pilates-rose text-pilates-rose font-semibold text-xs px-4 py-1.5 mb-6 inline-block uppercase tracking-[0.2em] bg-white" data-id="element-31">
            5 PREMIUM BONUSES INCLUDED
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-blue-dark leading-tight mb-4 tracking-tight" data-id="element-32">
            Transform your daily coaching routine
          </h2>
          <p className="text-pilates-slate text-base sm:text-lg max-w-2xl mx-auto" data-id="element-33">
            Exclusive resources included for FREE with your bundle.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-34">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white rounded-lg p-6 shadow-sm border border-pilates-slate/10 hover:shadow-md hover:-translate-y-1 transition-all duration-300 flex flex-col" data-id="element-35">
              <div className="relative mb-5 overflow-hidden rounded-md bg-pilates-cream aspect-square border border-pilates-slate/5" data-id="element-36">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width="400" height="400" data-id="element-37" />
                <div className="absolute top-3 left-3 bg-pilates-blue-dark text-white text-xs font-bold px-3 py-1.5 rounded-sm uppercase tracking-wide shadow-md flex items-center gap-1.5" data-id="element-38">
                  <Star className="w-3 h-3 text-pilates-lavender" fill="currentColor" data-id="element-39" />
                  {bonus.number}
                </div>
                <div className="absolute top-3 right-3 bg-pilates-lavender text-pilates-blue-dark text-[10px] font-bold px-2.5 py-1 rounded-sm uppercase tracking-wider shadow-md" data-id="element-40">
                  Free
                </div>
              </div>
              <div className="flex items-center justify-between mb-2 gap-2" data-id="element-41">
                <h3 className="font-display font-semibold text-pilates-blue-dark text-lg leading-tight" data-id="element-42">
                  {bonus.title}
                </h3>
                <span className="text-pilates-rose font-bold text-xs whitespace-nowrap" data-id="element-43">
                  {bonus.value}
                </span>
              </div>
              <p className="text-pilates-slate text-sm leading-relaxed" data-id="element-44">
                {bonus.desc}
              </p>
            </div>)}

          {/* Decorative card showing total value */}
          <div className="bg-pilates-blue-dark border-2 border-pilates-lavender rounded-lg p-6 shadow-md flex flex-col items-center justify-center text-center text-white" data-id="element-45">
            <Volleyball className="w-12 h-12 text-pilates-lavender mb-4" data-id="element-46" />
            <p className="text-white/80 text-sm uppercase tracking-wider mb-2" data-id="element-47">
              All included in
            </p>
            <p className="font-display text-3xl font-semibold text-pilates-lavender mb-3" data-id="element-48">
              the 6-in-1 Bundle
            </p>
            <p className="text-white/75 text-sm leading-relaxed" data-id="element-49">
              All 5 bonuses are included for free with your purchase today.
            </p>
          </div>
        </div>
      </div>
    </section>;
}